import React from 'react';
import { formatPhoneNumber, formatOpenDays } from '../../../utils/format';

export const PoiDetail = ({ data }) => (
  <>
    <div className="tour-detail__title-block">
      <div className="tour-detail__title-text">{data.tour_name || '-'}</div>
      <div className="tour-detail__title-tag">
        {data.tour_type === 'museum' ? '박물관' : 
         data.tour_type === 'gallery' ? '미술관' : 
         data.tour_type === 'atelier' ? '아틀리에' : 
         data.tour_type === 'studio' ? '스튜디오' : 
         data.tour_type === 'residency' ? '레지던시' : '아틀리에'}
      </div>
    </div>

    <div className="tour-detail__info-text">정보</div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_address.svg" />
      <div className="tour-detail__detail-text">{data.tour_location || '-'}</div>
    </div>

    <div className="tour-detail__detail-block">
      <img className="tour-detail__detail-icon" src="icons/icon_phone.svg" />
      <div className="tour-detail__detail-text">{formatPhoneNumber(data.tour_phone)}</div>
    </div>

    {data.tour_open_days && (
      <div className="tour-detail__detail-block">
        <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
        <div className="tour-detail__detail-text">{formatOpenDays(data.tour_open_days)}</div>
      </div>
    )}

    {data.tour_open_time && (
      <div className="tour-detail__detail-block">
        <img className="tour-detail__detail-icon" src="icons/icon_opentime.svg" />
        <div className="tour-detail__detail-text">{data.tour_open_time}</div>
      </div>
    )}

    {data.tour_website && (
      <div className="tour-detail__detail-block">
        <img className="tour-detail__detail-icon" src="icons/icon_homepage.svg" />
        <div className="tour-detail__detail-text">{data.tour_website}</div>
      </div>
    )}

    {data.tour_description && (
      <div className="tour-detail__detail-block">
        <img className="tour-detail__detail-icon" src="icons/icon_introduce.svg" />
        <div className="tour-detail__detail-text">{data.tour_description}</div>
      </div>
    )}

    <div className="tour-detail__map-buttons">
      <a href={`https://map.kakao.com/link/map/${data.tour_name},${data.tour_location_lat},${data.tour_location_lng}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__kakao-map-button" src="/icons/btn_kakao_map.svg" alt="카카오맵" />
      </a>
      {/* <a href={`https://map.naver.com/v5/search/${data.tour_name}?c=/${data.tour_location_lng},${data.tour_location_lat}`} target="_blank" rel="noopener noreferrer">
        <img className="tour-detail__naver-map-button" src="/icons/btn_naver_map.svg" alt="네이버맵" />
      </a> */}
    </div>
  </>
);